import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StateService } from "@uirouter/core";
import { Observable } from 'rxjs';
import { IProject } from 'src/app/project-display/interfaces/IProject';
import { IProjectContract } from 'src/app/project-display/interfaces/IProjectContract';
import { IProjectContractStage } from 'src/app/project-display/interfaces/IProjectContractStage';
import { IProjectSummary } from 'src/app/project-display/interfaces/IProjectSummary';
import { urlEncode } from 'src/app/util/util';
import { EntityNavigationHost } from 'src/app/assets/shared/entity-navigation-host';

@Component({
  selector: 'eic-contract-stages-container',
  templateUrl: './contract-stages-container.component.html',
  styleUrls: ['../../../project-display.styles.scss',
    './contract-stages-container.component.scss']
})
export class ContractStagesContainerComponent {
  @Input() projectContractStages$: Observable<IProjectContractStage[]>;
  @Input() currentProject: { id: number, name: string };
  @Output() contract_selected = new EventEmitter();
  @Output() project_selected = new EventEmitter();

  constructor(
    private $state: StateService,
    private host: EntityNavigationHost
  ) {

  }

  projectSelected(project: IProjectSummary) {
    this.$state.go("search.project", { projectID: project.projectID, projectName: urlEncode(project.name) });
  }

  contractSelected(contract: IProjectContract) {
    this.host.openEntity({
      entityType: 'contract',
      id: contract.contractID,
      name: this.contractLabel(contract)
    });
  }

  private contractLabel(contract: IProjectContract): string {
    const contractSummary = contract as IProjectContract & { shortContractType?: string };
    const contractType = String(contract.contractType || '').trim();
    const description = String(contract.description || '').trim();

    if (contractType && description) {
      return `${contractType}: ${description}`;
    }

    return String(contractSummary.shortContractType || '').trim() || `Contract ${contract.contractID}`;
  }
}